// @flow
import { MEDIA_URL } from '../../../config/'
export default function getImageSource(source: ?string): ?string {
  if (!!source && !/^http/.test(source)) {
    return `${window.location.origin}${MEDIA_URL}/${source}`
  }
  return source
}



// WEBPACK FOOTER //
// ./src/services/mycharity/media/getImageSource.js